import PropTypes from "prop-types"

const ConditionalRender = ({ shouldRender, children, fallback }) =>
  shouldRender
    ? typeof children === "function"
      ? children()
      : children
    : fallback

ConditionalRender.defaultProps = {
  fallback: null,
}

ConditionalRender.propTypes = {
  shouldRender: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  fallback: PropTypes.node,
}
export default ConditionalRender
